export const KR = {
    //header
    "label_header_home": "Home",
    "label_header_company": "Company",
    "label_header_solution": "Solution",
    "label_header_product": "Products",
    //footer
    "label_footer_contact_text": "Contact Us",
    "label_footer_email": " Email",
    "label_footer_email_text": "ar247@ar247.co.kr",
    "label_footer_fax": "Fax",
    "label_footer_fax_num": "+82-31-716-1374",
    "label_footer_location": "Location",
    "label_footer_social": "Social Media",
    "label_footer_policy": "Privacy Policy",
    "label_footer_service": "Terms of Service",
    "label_footer_copyright": "Copyright © 2025 AR247. All Rights reserved.",
    //home
    "label_home_logo": "AR247",
    "label_home_subTitle_a": "Driving the Future : ",
    "label_home_subTitle_b": "Autonomous Innovation",
    "label_home_overview": "회사 개요",
    "label_home_overview_eng": "Company Overview",
    "label_home_autonomous_lab": "‘실내외 완전 무인 자율주행 로봇’ 연구소",
    "label_home_autonomous_lab_eng": "Autonomous Indoor-Outdoor Robot Lab",
    "label_home_slam": "SLAM",
    "label_home_ai": "AI",
    "label_home_motion": "MOTION",
    "label_home_delivery": "Delivery",
    "label_home_logistics": "Logistics",
    "label_home_solution": "Solution",
    "label_home_pro_tech": "보유 기술",
    "label_home_pro_tech_eng": "Proprietary Technologies",
    "label_home_slam_full": "Simultaneous Localization and Mapping",
    "label_home__ai_full": "Detection and Safe Autonomous Navigation",
    "label_home_product_overview": "제품 개요",
    "label_home_product_overview_eng": "Product Overview",
    "label_home_delivery_robot": "배송 로봇",
    "label_home_logi_robot": "물류 로봇",
    "label_home_total_solution": "통합 IT 솔루션",
    "label_home_delivery_robot_detail": "배로미, 배로미 미니, 스스로 등",
    "label_home_logi_robot_detail": "AMR 및 아웃도어 AMR",
    "label_home_total_solution_detail": "FMS(Fleet Management System), 주문 확인 및 관리자 앱 등",
    //company
    "label_company_overview_title": "AR247 - 완전 무인 자율주행의 새로운 패러다임",
    "label_company_overview": "Company Overview",
    "label_company_overview_content_a": "AR247은 첨단 자율주행 로봇 연구개발을 통해 다양한 분야의 라스트 마일 문제를 해결하는 연구소입니다.",
    "label_company_overview_content_b": "우리의 비전은 미래 이동 혁신을 선도하는 글로벌 자율주행 로봇 리더로서, 배달, 물류, 서비스 산업 전반에 걸친 로봇 솔루션을 제공하여 전 세계 라스트 마일 배송의 효율성을 극대화하고, 사람들의 삶을 더욱 편리하게 만드는 것입니다.",
    "label_company_overview_content_c": "  우리는 첨단 자율주행 기술을 기반으로 안전하고 효율적인 라스트 마일 솔루션을 제공하며, 실내외 다양한 환경에서 신뢰성 높은 로봇을 개발합니다. LiDAR 및 카메라 기반 인공지능 기술을 통해 사람과 환경을 고려한 안전한 이동을 보장하고, 지속 가능한 물류 솔루션을 제공합니다.",
    "label_company_history": "회사 연혁",
    "label_company_history_eng": "History",
    "label_company_year_2024": "2024",
    "label_company_year_2023": "2023",
    "label_company_year_2022": "2022",
    "label_company_year_2021": "2021",
    "label_company_year_2020": "2020",
    "label_company_direction": "오시는 길",
    "label_company_direction_eng": "Directions",
    "label_company_direction_address": "주소",
    "label_company_direction_address_eng": "Address",
    "label_company_direction_address_detail": "경기도 성남시 분당구 성남대로 69 로드랜드EZ타워 407호",
    "label_company_direction_fax": "팩스",
    "label_company_direction_fax_eng": "Fax",
    "label_company_direction_fax_detail": "+82-31-716-1374",
    "label_company_direction_mail": "이메일",
    "label_company_direction_mail_eng": "E-mail",
    "label_company_direction_mail_detail": "ar247@ar247.co.kr",
    //solution
    "label_solution_service": "라스트 마일 서비스",
    "label_solution_service_eng": "Last Mile Service",
    "label_solution_service_route": "무인 운행 경로",
    "label_solution_service_auto_operation": "완전 자동화 운영",
    "label_solution_service_total_solution": "통합 IT 솔루션 제공",
    "label_solution_ind_intro": "사업 소개",
    "label_solution_ind_intro_eng": "Industries",
    "label_solution_ind_delivery_robot": "배송 로봇",
    "label_solution_ind_logi_robot": "물류 로봇",
    "label_solution_ind_total_solution": "통합 IT 솔루션",
    "label_solution_ind_delivery_detail": "소형 화물을 목적지까지 안전하고 정확하게 운송하며, AI 기반 자율주행 기술과 최적화된 경로 탐색 시스템을 적용해 도심 환경에서도 효율적 배송 서비스를 제공합니다.",
    "label_solution_ind_logi_detail": "창고 및 물류 센터에서 화물의 자동 이송과 적재를 수행하며, 물류 작업의 속도와 정확성을 향상시킵니다. 로봇 제어 기능을 활용해 작업자의 부담을 줄이고, 효율적인 운영을 지원합니다.",
    "label_solution_ind_total_detail": "자율주행 로봇을 플랫폼에서 관리할 수 있도록 지원합니다. 실시간 데이터, 원격 제어, 운영 최적화를 통해 스마트 물류 환경을 구축합니다.",
    "label_solution_case": "서비스 활용 예시",
    "label_solution_case_eng": "Service Use Cases",
    "label_solution_case_delivery_service": "배송 서비스 로봇",
    "label_solution_case_delivery_service_detail": "책 대출 및 반납 서비스/캠퍼스 배송 서비스/F&B 식품 배송 서비스/쇼핑몰 층간 물품 이동",
    "label_solution_case_drone": "드론-로봇 연계형 물류 서비스",
    "label_solution_case_drone_detail": "주소 기반 드론&로봇 연계 물품 배송 서비스",
    "label_solution_case_protect": "순찰 및 보안 서비스 로봇",
    "label_solution_case_protect_detail": "특정 지역 자동 순찰하는 보안 유지 서비스/여성 안심귀가 연동형 서비스",
    //products
    "label_products_delivery_robot": "배송 로봇",
    "label_products_delivery_robot_eng": "Delivery Robot",
    "label_products_delivery_baeromi": "배로미 BAEROMI",
    "label_products_delivery_baeromi_detail": "라이다 센서를 기반으로 한 실외 이동형 완전 자율주행 로봇으로, 실내·실외의 복잡한 환경에서도 높은 운행 안정성을 유지하며 24시간 연속 운행이 가능합니다.",
    "label_products_detail_robot_size": "기체 크기",
    "label_products_detail_box_size": "적재함 크기",
    "label_products_detail_max_quantity": "최대 적재 물량",
    "label_products_detail_speed": "운행 속도",
    "label_products_detail_angle": "최대 경사 각도",
    "label_products_detail_sensor": "센서 종류",
    "label_products_detail_feature": "제품 주요 기능 및 특징",
    "label_products_service": "서비스 활용 예시",
    "label_products_service_eng": "Service Use Cases",
    "label_products_baeromi_mini": "배로미 미니",
    "label_products_detail_size": "사이즈",
    "label_products_detail_box": "적재함",
    "label_products_detail_box_weight": "최대 적재 무게",
    "label_products_seuseuro": "스스로",
    "label_products_logi": "물류 로봇",
    "label_products_logi_eng": "Logistics Robot",
    "label_products_logi_steel": "철강산업",
    "label_products_logi_car": "자동차 산업",
    "label_products_logi_airplane": "항공 산업",
    "label_products_logi_big": "대용량 부품 운반",
};